export default __webpack_public_path__ + "static/media/north-arrow.b0785f5b.png";